import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-help-card',
  standalone: true,
  imports: [CommonModule, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem],
  templateUrl: './help-card.component.html',
  styleUrls: ['./help-card.component.scss']
})
export class HelpCardComponent {
  contactSupport() {
    var actionUrl = "mailto://IWB_Support@isg-one.com?subject=";
    window.open(actionUrl, "_self", 'noreferrer');
  }
}
